import { useState, useMemo } from 'react';
import './style.scoped.css';
import Toolbar from 'src/components/Toolbar';
import TabSelector from 'src/components/TabSelector';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { confirmQuit, showError, isEmpty, goBackCustom } from 'src/utils';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import InfoIcon from 'src/assets/info_icon.svg';
import paymentSt, { PaymentStore } from 'src/stores/PaymentStore';
import { observer } from 'mobx-react-lite';
import Periodic from 'src/screens/PolicyPayment/Periodic';
import OtherFee from 'src/screens/PolicyPayment/OtherFee';
import { checkExistOverdueAndDue } from 'src/utils/Policy';
dayjs.extend(customParseFormat);

interface PolicyPaymentObserverProps {
  paymentStore?: PaymentStore;
}
const PolicyPaymentObserver = observer(({ paymentStore } : PolicyPaymentObserverProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(0);
  
  const listTab = useMemo(() => {
    return [
      { id:0, text: t('periodic') }, 
      { id:1, text: t('other_fee') }
    ]
  }, [t]);

  const _handleChangeTab = (tab) => {
    if(tab == 0 ){
      setActiveTab(0);
    }else{
      let periodicPaymentInfo = paymentStore?.periodicPaymentInfo ?? {};
      if(checkExistOverdueAndDue(periodicPaymentInfo.duePremium)){
        showError(t('msg_06'));
        return;
      }
      if(isEmpty(paymentStore?.topUpPaymentInfo)){
        paymentStore?.getTopUpPolicyPayment({
          policyNum: periodicPaymentInfo?.policyNum,
          bgIndex: periodicPaymentInfo?.bgIndex,
          history: null,
          showDetail: false
        }).then(value => {
          setActiveTab(1);
        });
      }else{
        setActiveTab(1);
      }
    }
  };

  const _handleClose = () => {
    confirmQuit(history, InfoIcon);
  };

  const _handleBack = () => {
    goBackCustom(history);
  };

  return (
    <div className="screen-container bg-background view-policy-payment">
      <Toolbar
        title={t('payment')}
        showClose={true}
        onClose={_handleClose}
        onBack={_handleBack}
      />
      <div className="px-4 pt-4">
        <TabSelector
          value={activeTab}
          list={listTab}
          onChange={_handleChangeTab}
        />
      </div>
      {activeTab == 0 ? <Periodic /> : <OtherFee />}
    </div>
  );
});

const PolicyPayment = () => <PolicyPaymentObserver paymentStore={paymentSt} />;
export default PolicyPayment;
